import React, { useContext, useState, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { MenuItems } from '@ikea-food-ux/ppsi';
import { useHistory, useLocation } from 'react-router-dom';
import Pill from "@ingka/pill";
import filtersIcon from '@ingka/ssr-icon/paths/filters.js';
import styled from 'styled-components';
import theme from '../ui/theme';
import useLabels from '../Internationalization/useLabels';
import LanguageDropdown from '../LanguageDropdown';
import useRoutes from '../../routes/useRoutes';
import DataContext from '../DataContext/DataContext';
import TextTranslatable from '../Internationalization/TextTranslatable';
import { fetchRefresh } from '../../api';
import FeedbackView from '../../views/FeedbackView';
import SearchInput from '../SearchInput';

const ContainerStyle = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 64px;
  padding: 1rem 1.3rem;
  display: flex;
  align-items: center;
  color: ${theme.color.white};
  z-index: 0;
  background: ${theme.color.blue};
  justify-content: space-between;
`;

const LeftContainer = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
`;

const CenterContainer = styled.div`
  display: flex;
  justify-content: center;
  flex: 1;
`;

const AppTitle = styled.h4`
  font-size: 1.25rem;
  font-weight: 700;
  color: ${props => props.item === false ? '#fff' : '#82ba04'};
  cursor: ${props => props.item === false ? 'default' : 'pointer'};
  margin: 0;
`;

const FeedbackMenu = styled.span`
  font-weight: bold;
  text-transform: capitalize;
  min-width: 100px;
  margin-left: 20px;
  cursor: pointer;
`;

const LinkContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  align-items: center;
`;

const Link = styled(RouterLink)`
  color: #fff;
  text-decoration: none;
  font-size: 0.875rem;
  font-weight: 700;
  padding: 0 5px;
  min-width: 50px;
  min-height: 62px;
  padding-top: 20px;

  @media (min-width: 640px) {
    padding: 0 10px;
    font-size: 1rem;
    min-height: 62px;
    padding-top: 20px;
  }
  @media (min-width: 768px) {
    padding: 0px 15px;
    min-width: 60px;
    min-height: 62px;
    padding-top: 20px;
  }
  @media (min-width: 1024px) {
    padding: 0 15px;
    min-width: 70px;
    min-height: 62px;
    padding-top: 20px;
  }
`;

const StyledPill = styled(Pill)`
  background: transparent;
  border: none;
  color: white;
  height: auto;

  &:hover {
    background: none;
  }
`;

function NavBar() {
  const routes = useRoutes();
  const { isFetching, org, refreshCount, handleQueryChange, query, showSuggestion, setShowSuggestion, checkDataLength  } = useContext(DataContext);
  // const [wakeLockOn, setWakeLockOn] = useState(false)
 
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [updater, setUpdater] = useState(0)
  const [isModalOpen, setModalOpen] = useState(false);
  // const [released, setReleased] = useState(false)
  const history = useHistory();
  const location = useLocation();
  const [alphabeticLabel,newLabel,updatedLabel] = useLabels('sorting_alphabetic','sorting_new','sorting_updated');
//  const selectedMarketLangStr = localStorage.getItem('selectedMarketLang');
//  const selectedMarketLang = selectedMarketLangStr ? JSON.parse(selectedMarketLangStr) : null;
 
//  const isArabicMarket = selectedMarketLang?.countryCode === "EG";
//  document.documentElement.setAttribute('dir', isArabicMarket ? 'rtl' : 'ltr');
 // Get path parts from the current URL
const pathParts = window.location.pathname.split("/");

// Example: ["", "dppsi", "EG", "AR", "menu"]
const countryCode = pathParts[2] || null; 

// Check if Arabic market (Egypt in this case)
const isArabicMarket = countryCode === "EG";

// Apply direction
document.documentElement.setAttribute("dir", isArabicMarket ? "rtl" : "ltr");
  // The wake lock sentinel -- AS PART OF ifppsi-719 CR.
let wakeLock = null;
 
// Function that attempts to request a screen wake lock.
const requestWakeLock = async () => {
  try {
    wakeLock = await navigator.wakeLock.request();
    wakeLock.addEventListener('release', () => {
      console.log('Screen Wake Lock released:', wakeLock.released);
    });
    // console.log('Screen Wake Lock released:', wakeLock.released);
  } catch (err) {
    console.error(`${err.message}`);
  }
};
 
    let getTime = new Date();
    let midnight = new Date();
    midnight.setHours(24, 0, 0, 0);
    let timeUntilMidnight = midnight - getTime;
// Request a screen wake lock
requestWakeLock();
 
// function updateMidnight(){
//   setTimeout(()=>{
//     midnight = new Date();
//     midnight.setHours(13, 25, 0, 0);
//   }, 3000)
// }
 
  useEffect(()=>{
    document.addEventListener('visibilitychange', handleVisibilityChange);
 
    let interval = setInterval(async () => {
      const res = await fetchRefresh(org);
      getTime = new Date();
      setUpdater(res.data.counter);
      if(getTime.getHours() == 24 && getTime.getMinutes() < 6){
            midnight = new Date();
            midnight.setHours(24, 0, 0, 0);
      }
    }, 300000);
    setSelectedIndex(2);
 
    setTimeout(()=>{
      wakeLock != null && wakeLock.release();
    }, timeUntilMidnight)
 
    return () => {
      clearInterval(interval);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
 
  },[location.pathname])
  const handleOpenModal = () => {
    setModalOpen(true);
  };
  const handleCloseModal = () => {
    setModalOpen(false);
  };
  const saveSelectedMenu = (item, index) => {
 
    if (location.pathname !== 'undefined' && location.pathname !== null) {
      history.replace({
        pathname: location.pathname,
        data: { menuSelected: item }
      });
    }
    setSelectedIndex(index);
    // setSelectedMenu(item)
  };
  const menuListItems = [
    { key: 'alphabetic', value: alphabeticLabel},
    { key: 'new', value: newLabel },
    { key: 'updated', value: updatedLabel }
  ];
 
  if (isFetching) {
    return <ContainerStyle />;
  };
 
 
async function handleVisibilityChange(){
  let getTimes = new Date();
  let checkTime = getTimes.getHours() == 24 && getTimes.getMinutes() < 6;
  if(wakeLock === null){
    return;
  }else if(wakeLock.released === true && document.visibilityState === 'visible' && !checkTime){
    await requestWakeLock();
    console.log('wake lock is active')
  }else {
    return;
  }
}
 
const isErrorPage = location.pathname === '/error';
 
  function updatePage(){
    if(updater > refreshCount){
    window.location.reload();
    }
  }

  return (
    <>
      <ContainerStyle>
        <LeftContainer>
          <AppTitle item={updater > refreshCount} onClick={() => window.location.reload()}>
            <TextTranslatable textId="title" />
          </AppTitle>
          {isErrorPage!==true &&  <>
          <span className='feedbackMenu' onClick={handleOpenModal}>
            <TextTranslatable textId="feedback" />
          </span>
          <LanguageDropdown />
          </>
}
        </LeftContainer>
        {isErrorPage!==true &&  <>
        <CenterContainer>
          <SearchInput query={query} onQueryChange={handleQueryChange} showSuggestion={showSuggestion} setShowSuggestion={setShowSuggestion} checkDataLength={checkDataLength}/>
        </CenterContainer>

        <LinkContainer>
          <Link to={routes.menuRoute()} key="menu" className={location.pathname.indexOf('menu') > -1 ? 'underlined' : ''}>
            <TextTranslatable textId="menu" />
          </Link>
          <Link to={routes.prepAndProdCheatSheetRoute()} key="production" className={location.pathname.indexOf('prepAndProd') > -1 ? 'underlined' : ''}>
            <TextTranslatable textId="nav_preparation_and_production" />
          </Link>
          <Link to={routes.settingsPageRoute()} key="settings" className={location.pathname.indexOf('settings') > -1 ? 'underlined' : ''}>
            <StyledPill iconOnly={true} ssrIcon={filtersIcon} />
          </Link>
        </LinkContainer>
        </>
}
      </ContainerStyle>

      {isModalOpen && <FeedbackView isOpen={isModalOpen} onClose={() => setModalOpen(false)} />}
    </>
  );
}

export default NavBar;
